module.exports = __webpack_public_path__ + "img/diaphorina-citri.47e578b1.jpg";